import React from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
import { MEDIA_BASE_URL } from '../../../api'
import '../productPages.css'

function Whr_wynberg() {
    const images = [1, 2, 3, 4, 5, 6, 7].map(n => `${MEDIA_BASE_URL}/machines-images/Waste Heat Recovery/b${n}.jpg`)
    return (
        <div>
            <Navbar />
            <div className='pp-gallery'>
                {images.map((image, index) => (<img key={index} src={image} alt={`Slide ${index + 1}`} loading='lazy' />))}
            </div>
            <Footer />
        </div>
    )
}

export default Whr_wynberg
